import React, { useState, useEffect, createContext, useContext, useRef } from "react";
import { Grid } from "@mui/material";
import { Outlet, useLocation, Link } from "react-router-dom";
import { LocaleContext } from "../../routing/LangRouter";
import { useTranslation } from "react-i18next";

//import images
import { ArrowLeft2 } from "iconsax-react";

//import styles
import "./itinerary-layout.scss";

export const ItineraryContext = createContext({
    routes: [],
    // eslint-disable-next-line
    setRoutes: newRoute => {},
});

const ItineraryLayout = () => {
    const location = useLocation(),
        { locale } = useContext(LocaleContext);
    const [routes, setRoutes] = useState([]);
    const routesValue = { routes, setRoutes };
    const { t } = useTranslation();
    const menuRef = useRef(null);

    useEffect(() => {
        const visitedRoutes = JSON.parse(sessionStorage.getItem("visitedRoutes"));
        if (visitedRoutes && visitedRoutes.length) setRoutes(visitedRoutes);
        else setRoutes([`/${locale}/itinerary/favorites`]);
    }, []);

    useEffect(() => {
        if (location.pathname === `/${locale}/itinerary/itinerary-page`) {
            menuRef.current.scrollBy({ left: -100, behavior: "smooth" });
        } else menuRef.current.scrollBy({ left: 100, behavior: "smooth" });
    }, [location]);

    return (
        <div className="itinerary-layout">
            <ItineraryContext.Provider value={routesValue}>
                <Grid
                    className="itinerary-layout__menu"
                    container
                    item
                    xs="auto"
                    columnGap={{ xs: 0, md: 1 }}
                    justifyContent={{ xs: "space-evenly", sm: "flex-start" }}
                    alignItems="center"
                    ref={menuRef}
                >
                    <Grid className="itinerary-layout__menu-item" container item xs="auto">
                        <Link className={`itinerary-layout__menu-link visited`} to={`/${locale}/`}>
                            <span>{t("homePage")}</span>
                        </Link>
                        <ArrowLeft2
                            className="itinerary-layout__mobile-icon"
                            size="16"
                            color={
                                location.pathname === `/${locale}/itinerary/favorites`
                                    ? "var(--primary-color)"
                                    : routes.includes(`/${locale}/itinerary/favorites`)
                                    ? "var(--secondary-color)"
                                    : "var(--medium-gray-color)"
                            }
                            variant="Outline"
                        />
                    </Grid>
                    <Grid className="itinerary-layout__menu-item" container item xs="auto">
                        <Link
                            className={`itinerary-layout__menu-link 
                            ${
                                location.pathname === `/${locale}/itinerary/favorites`
                                    ? "active"
                                    : routes.includes(`/${locale}/itinerary/favorites`)
                                    ? "visited"
                                    : ""
                            }`}
                            to={
                                routes.includes(`/${locale}/itinerary/favorites`)
                                    ? { pathname: `/${locale}/itinerary/favorites` }
                                    : { pathname: location.pathname }
                            }
                        >
                            {/* <PreferencesWizard
                                className={`itinerary-layout__favorite-icon ${routes.includes(`/${locale}/itinerary/favorites`) ? "active" : ""}`}
                            /> */}
                            <span>{t("favorites")}</span>
                        </Link>
                        <ArrowLeft2
                            className="itinerary-layout__mobile-icon"
                            size="16"
                            color={
                                location.pathname === `/${locale}/itinerary/favorites`
                                    ? "var(--primary-color)"
                                    : routes.includes(`/${locale}/itinerary/favorites`)
                                    ? "var(--secondary-color)"
                                    : "var(--medium-gray-color)"
                            }
                            variant="Outline"
                        />
                        {/* <span
                            className={`itinerary-layout__line 
                        ${
                            routes.includes(`/${locale}/itinerary/domestic-flight`) ||
                            routes.includes(`/${locale}/itinerary/train`) ||
                            routes.includes(`/${locale}/itinerary/bus`)
                                ? "active"
                                : ""
                        }`}
                        ></span> */}
                        {/* <span
                            className={`itinerary-layout__circle 
                            ${
                                routes.includes(`/${locale}/itinerary/domestic-flight`) ||
                                routes.includes(`/${locale}/itinerary/train`) ||
                                routes.includes(`/${locale}/itinerary/bus`)
                                    ? "active"
                                    : ""
                            }`}
                        >
                            <span className="itinerary-layout__inside-circle"></span>
                        </span> */}
                    </Grid>
                    <Grid className="itinerary-layout__menu-item" container item xs="auto">
                        <Link
                            className={`itinerary-layout__menu-link ${
                                location.pathname === `/${locale}/itinerary/domestic-flight` ||
                                location.pathname === `/${locale}/itinerary/international-flight`
                                    ? "active"
                                    : routes.includes(`/${locale}/itinerary/domestic-flight`) ||
                                      routes.includes(`/${locale}/itinerary/international-flight`) ||
                                      routes.includes(`/${locale}/itinerary/train`) ||
                                      routes.includes(`/${locale}/itinerary/bus`)
                                    ? "visited"
                                    : ""
                            }`}
                            to={
                                routes.includes(`/${locale}/itinerary/domestic-flight`)
                                    ? { pathname: `/${locale}/itinerary/domestic-flight` }
                                    : routes.includes(`/${locale}/itinerary/international-flight`)
                                    ? { pathname: `/${locale}/itinerary/international-flight` }
                                    : { pathname: location.pathname }
                            }
                        >
                            {/* <TicketWizard
                                className={`itinerary-layout__ticket-icon ${
                                    routes.includes(`/${locale}/itinerary/domestic-flight`) ||
                                    routes.includes(`/${locale}/itinerary/train`) ||
                                    routes.includes(`/${locale}/itinerary/bus`)
                                        ? "active"
                                        : ""
                                }`}
                            /> */}
                            <span>{t("ticketSelection")}</span>
                        </Link>
                        <ArrowLeft2
                            className="itinerary-layout__mobile-icon"
                            size="16"
                            color={
                                location.pathname === `/${locale}/itinerary/domestic-flight` || location.pathname ===`/${locale}/itinerary/international-flight`
                                    ? "var(--primary-color)"
                                    : routes.includes(`/${locale}/itinerary/domestic-flight`) ||
                                      routes.includes(`/${locale}/itinerary/international-flight`)
                                    ? "var(--secondary-color)"
                                    : "var(--medium-gray-color)"
                            }
                            variant="Outline"
                        />
                        {/* <span className={`itinerary-layout__line ${routes.includes(`/${locale}/itinerary/hotel`) ? "active" : ""}`}></span> */}
                        {/* <span
                            className={`itinerary-layout__circle ${
                                routes.includes(`/${locale}/itinerary/hotel`)
                                    ? "active"
                                    : routes.includes(`/${locale}/itinerary/hotel`)
                                    ? "visited"
                                    : ""
                            }`}
                        >
                            <span className="itinerary-layout__inside-circle"></span>
                        </span> */}
                    </Grid>
                    <Grid className="itinerary-layout__menu-item" container item xs="auto">
                        <Link
                            className={`itinerary-layout__menu-link ${
                                location.pathname === `/${locale}/itinerary/hotel`
                                    ? "active"
                                    : routes.includes(`/${locale}/itinerary/hotel`)
                                    ? "visited"
                                    : ""
                            }`}
                            to={
                                routes.includes(`/${locale}/itinerary/hotel`)
                                    ? { pathname: `/${locale}/itinerary/hotel` }
                                    : location.pathname
                            }
                        >
                            {/* <HotelWizard
                                className={`itinerary-layout__hotel-icon ${routes.includes(`/${locale}/itinerary/hotel`) ? "active" : ""}`}
                            /> */}
                            <span>{t("hotelSelection")}</span>
                        </Link>
                        <ArrowLeft2
                            className="itinerary-layout__mobile-icon"
                            size="16"
                            color={
                                location.pathname === `/${locale}/itinerary/hotel`
                                    ? "var(--primary-color)"
                                    : routes.includes(`/${locale}/itinerary/hotel`)
                                    ? "var(--secondary-color)"
                                    : "var(--medium-gray-color)"
                            }
                            variant="Outline"
                        />
                        {/* <span className={`itinerary-layout__line ${routes.includes(`/${locale}/itinerary/itinerary-page`) ? "active" : ""}`}></span>
                        <span className={`itinerary-layout__circle ${routes.includes(`/${locale}/itinerary/itinerary-page`) ? "active" : ""}`}>
                            <span className="itinerary-layout__inside-circle"></span>
                        </span> */}
                    </Grid>
                    <Grid className="itinerary-layout__menu-item" container item xs="auto">
                        <Link
                            className={`itinerary-layout__menu-link ${
                                location.pathname === `/${locale}/itinerary/itinerary-page`
                                    ? "active"
                                    : routes.includes(`/${locale}/itinerary/itinerary-page`)
                                    ? "visited"
                                    : ""
                            }`}
                            to={
                                routes.includes(`/${locale}/itinerary/itinerary-page`)
                                    ? { pathname: `/${locale}/itinerary/itinerary-page` }
                                    : location.pathname
                            }
                        >
                            {/* <ItineraryWizard
                                className={`itinerary-layout__itinerary-icon ${
                                    routes.includes(`/${locale}/itinerary/itinerary-page`) ? "active" : ""
                                }`}
                            /> */}
                            <span>{t("itinerary")}</span>
                        </Link>
                    </Grid>
                </Grid>
                <main>
                    <Outlet />
                </main>
            </ItineraryContext.Provider>
        </div>
    );
};
export default ItineraryLayout;
